export function getMatches(state) {
    const { results } = state.ui.companies;
    if (!results || !results.matches) {
        return [];
    }
    return results.matches.slice(0, 5);
}

export function getTopMatches(state) {
    const { results } = state.ui.companies;
    if (!results || !results.topMatches) {
        return [];
    }
    return results.topMatches;
}

export function getSuggestedMatches(state) {
    const { results } = state.ui.companies;
    if (!results || !results.suggestedMatches) {
        return [];
    }
    return results.suggestedMatches;
}

export function getPossibleMatches(state) {
    const { results } = state.ui.companies;
    if (!results) {
        return 0;
    }

    return results.possibleMatches;
}

export function getError(state) {
    return state.ui.companies.error;
}

export function getHasLoadedResults(state) {
    return state.ui.companies.hasLoadedResults || false;
}

export function getIsLoadingResults(state) {
    return state.ui.companies.isLoadingResults || false;
}

/**
 * Self onboarding doesn't need loading or error states since it exists
 * as a sanity check so the user doesn't accidentally create a duplicate company.
 * Loading an error states might be more of a distraction than an aid.
 */
export function getSelfOnboardingMatches(state) {
    return state.ui.companies.selfOnboardingMatches || [];
}

export function getOtherCompany(state) {
    return state.ui.companies.otherCompany || {};
}
